// members page
import React, { useState, useEffect } from "react";

import Button from "@mui/material/Button";
import withRouter from "../../components/routerhoc";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// css
import "../../css/style.css";
import theme from "../../css/theme";
import DeleteIcon from "@mui/icons-material/Delete";

import MembersDataTable from "./datatable";
import getMemberList from "./member_list";
import { useLocation } from "react-router-dom";

const Members = props => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const currentUser = useSelector(state => state.auth);
  const { user_id, user_type } = currentUser;
  const [loading, setLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);

  const currentMember = useLocation();
  console.log(`curent location MEMBERS `, currentMember);

  useEffect(() => {
    if (user_type === "GUEST") {
      navigate("/");
    }
    getMemberList(setLoading, setRows);
  }, [navigate, user_id, user_type]);
  // modifc in dependinte ??

  const addMember = () => {
    navigate("/editmember/new");
  };

  const selectRow = ids => {
    const selectedIDs = new Set(ids);
    const selectedRows = rows.filter(row => selectedIDs.has(row.id));
    setSelectedRows(selectedRows);
    console.log(`selected users : `, selectedRows);
  };

  const onDelete = member => {
    selectedRows.forEach(member => {
      axios
        .delete(`/api/user/delete/${member.member_id}`)
        .then(response => {
          console.log(`deleted member`);
          console.log(`response la delete?: `, response);
          getMemberList(setLoading, setRows);
        })
        .catch(error => {
          console.error(`Axios error /api/user/delete : `, error);
        });
    });
  };

  const onEdit = member => {
    // http localhost:5001/api/user/edit/9
    // name="Membru Editat" firstname="Echipa edit 4" sex="F" race="peste 45" team="individual" user_id:=4
    const memberObj = selectedRows[0];
    console.log(`member OBJ= `, memberObj);
    const { member_id } = memberObj;
    navigate(`/editmember/${member_id}`, { state: memberObj });
  };

  return (
    <div className="app-container">
      <main>
        <Button className="admin-buttons" variant="contained" theme={theme} type="submit" onClick={addMember}>
          Adauga ciclist
        </Button>

        <Button className="admin-buttons" variant="contained" theme={theme} type="submit" onClick={onEdit}>
          Editeaza ciclist
        </Button>

        <Button
          className="admin-buttons"
          variant="contained"
          theme={theme}
          startIcon={<DeleteIcon />}
          type="submit"
          onClick={onDelete}
        >
          Sterge ciclist
        </Button>

        <div>
          <MembersDataTable rows={rows} loading={loading} selectRow={selectRow} />
        </div>
      </main>
    </div>
  );
};
export default withRouter(Members);
